// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import ProductPrice from "@insite/content-library/Components/ProductPrice";
import { CommonProductCardProps, withProductCardCommonProps } from "@werner/App/Components/Product/common";
import ProductGridContainer, { ProductGridContainerStyle } from "@werner/App/Components/Product/ProductGridContainer";
import { mergeWithCss, sharedProductDescriptionStyles } from "@werner/XDL/Utilities";
import React, { useState } from "react";
import { css } from "styled-components";

export interface ProductSmallCardStyles {
    productGridContainerStyles?: ProductGridContainerStyle;
    productImage?: ProductImageStyles;
    productDescription?: ProductDescriptionStyles;
}

const productSmallCardStyles: ProductSmallCardStyles = {
    productGridContainerStyles: {
        container: {
            css: css`
                max-width: 198px;
            `,
        },
        image: {
            css: css`
                width: 198px;
                height: 198px;
                padding: 16px;
            `,
        },
        info: {
            css: css`
                padding: 20px 0 10px;
            `,
        },
    },
    productImage: {
        linkWrappingImage: {
            css: css`
                width: 162px;
                height: 162px;
            `,
        },
        img: {
            css: css`
                max-width: 100%;
                max-height: 100%;
                height: auto;
            `,
        },
    },
    productDescription: {
        ...sharedProductDescriptionStyles,
    },
};

type Props = CommonProductCardProps<ProductSmallCardStyles>;

const ProductSmallCard = ({ productContext, productSettings, showPrice, extendedStyles }: Props) => {
    const [styles] = useState(() => mergeWithCss(productSmallCardStyles, extendedStyles));
    return (
        <ProductGridContainer extendedStyles={styles.productGridContainerStyles}>
            <ProductGridContainer.Image>
                <ProductImage product={productContext} extendedStyles={styles.productImage} />
            </ProductGridContainer.Image>
            <ProductGridContainer.Info>
                <ProductDescription product={productContext} extendedStyles={styles.productDescription} />
            </ProductGridContainer.Info>
            <ProductGridContainer.Price>
                {showPrice && productSettings.canSeePrices && (
                    <ProductPrice
                        product={productContext}
                        showLabel={false}
                        showSavings={true}
                        showSavingsAmount={productSettings.showSavingsAmount}
                        showSavingsPercent={productSettings.showSavingsPercent}
                    />
                )}
            </ProductGridContainer.Price>
        </ProductGridContainer>
    );
};

export default withProductCardCommonProps(ProductSmallCard);
